// Constants used only by the Login feature.

// Federate client id per environment: the host's second label (beta / gamma / pdxprod), or for
// dev stacks ({alias}devaimsui.test...) the first label.
export const CLIENT_ID_BY_ENV = new Map([
  ["tlxudevaimsui", "tlxuzoomtest"],
  ["sharedevaimsui", "ZoomAiMSBeta"],
  ["ztongdevaimsui", "ZoomAiMSBeta"],
  ["ziyudevaimsui", "ZoomAiMSBeta"],
  ["mznwngdevaimsui", "ZoomAiMSBeta"],
  ["aldaodevaimsui", "ZoomAiMSBeta"],
  ["elbiedevaimsui", "ZoomAiMSBeta"],
  ["livesdevaimsui", "ZoomAiMSBeta"],
  ["abeesdevaimsui", "ZoomAiMSBeta"],
  ["vnadidevaimsui", "ZoomAiMSBeta"],
  ["tejavdevaimsui", "ZoomAiMSBeta"],
  ["qguvidevaimsui", "ZoomAiMSBeta"],
  ["pinyidevaimsui", "ZoomAiMSBeta"],
  ["liyucdevaimsui", "ZoomAiMSBeta"],
  ["ikaladevaimsui", "ZoomAiMSBeta"],
  ["beta", "ZoomAiMSBeta"],
  ["gamma", "ZoomAiMSBeta"],
  ["pdxprod", "ZoomAiMSProd"],
]);

export const IDP_BY_ENV = new Map([
  ["test", "https://idp-integ.federate.amazon.com"],
  ["beta", "https://idp-integ.federate.amazon.com"],
  ["gamma", "https://idp-integ.federate.amazon.com"],
  ["pdxprod", "https://idp.federate.amazon.com"],
]);

// Length of the generated OAuth state / nonce, and how long their cookies live (12h).
export const OAUTH_TOKEN_LENGTH = 64;
export const OAUTH_COOKIE_MAX_AGE_S = 43200;
